var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useBrokerFeatureLoader } from "../../redux/broker/broker.hooks";
import { EBrokerFeature } from "../../types/broker.types";
import { showAlert } from "../../utils/alert/alert.utils";
import { getLocalizedText } from "../../utils/i18n/i18n.utils";
import * as preferencesActions from "./preference.actions";
import { getLatePaymentPenaltyConfig, updateLatePaymentPenaltyConfig, } from "./preference.api";
import * as preferenceSelectors from "./preference.selectors";
export var useGetPreferences = function (key) {
    var dispatch = useDispatch();
    var isFetching = useSelector(function (state) {
        return preferenceSelectors.isFetchingPreferences(state, key) || false;
    });
    var fetchingError = useSelector(function (state) {
        return preferenceSelectors.fetchPreferenceError(state, key);
    });
    var items = useSelector(function (state) {
        return preferenceSelectors.getPreferences(state);
    });
    var fetchPreferences = function () {
        dispatch(preferencesActions.getPreferencesStart.getAction({
            key: key,
        }));
    };
    useEffect(function () {
        if (!key || isFetching) {
            return;
        }
        fetchPreferences();
    }, [key]);
    return {
        items: items,
        isFetching: isFetching,
        fetchingError: fetchingError,
        refetch: fetchPreferences,
    };
};
export var useCreatePreference = function (key) {
    var dispatch = useDispatch();
    var isCreating = useSelector(function (state) {
        return preferenceSelectors.isCreatingPreference(state, key) || false;
    });
    var createError = useSelector(function (state) {
        return preferenceSelectors.createPreferenceError(state, key);
    });
    var fetchPreferences = function () {
        dispatch(preferencesActions.getPreferencesStart.getAction({
            key: key,
        }));
    };
    var createPreference = function (data, onSuccess) {
        dispatch(preferencesActions.createPreferenceStart.getAction({
            data: data,
            onSuccess: function () {
                showAlert({
                    message: "Announcement has been created",
                    type: "success",
                });
                fetchPreferences();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            },
            onFailure: function (error) {
                showAlert({
                    message: error.message || "Announcement creation failed",
                    type: "error",
                });
            },
        }));
    };
    return {
        isCreating: isCreating,
        createError: createError,
        create: createPreference,
    };
};
export var useUpdatePreference = function (key) {
    var dispatch = useDispatch();
    var isUpdating = useSelector(function (state) {
        return preferenceSelectors.isUpdatingPreference(state, key) || false;
    });
    var updateError = useSelector(function (state) {
        return preferenceSelectors.updatePreferenceError(state, key);
    });
    var fetchPreferences = function () {
        dispatch(preferencesActions.getPreferencesStart.getAction({
            key: key,
        }));
    };
    var updatePreference = function (data, onSuccess) {
        dispatch(preferencesActions.updatePreferenceStart.getAction({
            key: key,
            data: data,
            onSuccess: function () {
                showAlert({
                    message: "Announcement has been updated",
                    type: "success",
                });
                fetchPreferences();
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            },
            onFailure: function (error) {
                showAlert({
                    message: error.message || "Announcement update failed",
                    type: "error",
                });
            },
        }));
    };
    return {
        isUpdating: isUpdating,
        updateError: updateError,
        update: updatePreference,
    };
};
export var useGetExtraChecklistConfig = function () {
    var dispatch = useDispatch();
    var isFetching = useSelector(function (state) {
        return preferenceSelectors.isFetchingExtraChecklistConfig(state) || false;
    });
    var fetchError = useSelector(function (state) {
        return preferenceSelectors.fetchExtraChecklistConfigError(state);
    });
    var data = useSelector(function (state) {
        return preferenceSelectors.getExtraChecklistConfig(state);
    });
    var fetch = function () {
        dispatch(preferencesActions.getExtraChecklistConfigStart.getAction({}));
    };
    useEffect(function () {
        if (isFetching) {
            return;
        }
        fetch();
    }, []);
    return {
        data: data,
        isFetching: isFetching,
        fetchError: fetchError,
        refetch: fetch,
    };
};
export var useUpdateExtraChecklistConfig = function () {
    var dispatch = useDispatch();
    var isUpdating = useSelector(function (state) {
        return preferenceSelectors.isUpdatingExtraChecklistConfig(state) || false;
    });
    var updateError = useSelector(function (state) {
        return preferenceSelectors.updateExtraChecklistConfigError(state);
    });
    var update = function (data, onSuccess, onFailure) {
        dispatch(preferencesActions.updateExtraChecklistConfigStart.getAction({
            data: data,
            onSuccess: function () {
                showAlert({
                    type: "success",
                    message: getLocalizedText("preferences.checklist_config.update.success"),
                });
                onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            },
            onFailure: function (error) {
                showAlert({
                    message: error.message,
                    type: "error",
                });
                onFailure === null || onFailure === void 0 ? void 0 : onFailure();
            },
        }));
    };
    return {
        isUpdating: isUpdating,
        updateError: updateError,
        update: update,
    };
};
export var useLatePaymentPenaltyConfig = function () {
    var _a = useBrokerFeatureLoader(EBrokerFeature.LatePaymentPenalty), isFetchingBroker = _a.isFetchingBroker, hasFeature = _a.hasFeature;
    var _b = useState(), data = _b[0], setData = _b[1];
    var _c = useState(true), isFetching = _c[0], setIsFetching = _c[1];
    var _d = useState(false), isUpdating = _d[0], setIsUpdating = _d[1];
    var _e = useState(false), fetchError = _e[0], setFetchError = _e[1];
    var refetch = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsFetching(true);
                    setFetchError(false);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    _a = setData;
                    return [4 /*yield*/, getLatePaymentPenaltyConfig()];
                case 2:
                    _a.apply(void 0, [_c.sent()]);
                    return [3 /*break*/, 5];
                case 3:
                    _b = _c.sent();
                    setFetchError(true);
                    return [3 /*break*/, 5];
                case 4:
                    setIsFetching(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, []);
    // Without the office feature the config is not fetched on mount.
    useEffect(function () {
        if (hasFeature) {
            void refetch();
        }
    }, [refetch, hasFeature]);
    var update = function (config) { return __awaiter(void 0, void 0, void 0, function () {
        var updated, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsUpdating(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateLatePaymentPenaltyConfig(config)];
                case 2:
                    updated = _a.sent();
                    setData(updated);
                    showAlert({
                        type: "success",
                        message: getLocalizedText("late_payment_penalty.settings.saved"),
                    });
                    return [2 /*return*/, updated];
                case 3:
                    error_1 = _a.sent();
                    showAlert({
                        type: "error",
                        message: (error_1 === null || error_1 === void 0 ? void 0 : error_1.message) || getLocalizedText("general.error"),
                    });
                    return [2 /*return*/, undefined];
                case 4:
                    setIsUpdating(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        data: data,
        isFetching: isFetchingBroker || (hasFeature && isFetching),
        hasFeature: hasFeature,
        isUpdating: isUpdating,
        fetchError: fetchError,
        refetch: refetch,
        update: update,
    };
};
